<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_69_145)">
			<path
				d="M40 0C17.9167 0 0 17.9167 0 40C0 62.09 17.9167 80 40 80C62.0867 80 80 62.09 80 40C80 17.9167 62.09 0 40 0ZM37.92 72.0667V46.9733H23.9667L44.01 7.93333V33.0267H57.44L37.92 72.0667Z"
				fill="#07887D" />
		</g>
		<defs>
			<clipPath id="clip0_69_145">
				<rect width="80" height="80" fill="#07887D" />
			</clipPath>
		</defs>
	</svg>
</template>